import AuthCallback from './AuthCallback'

export default AuthCallback
